import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ScrollToTop, LogoLoader, ErrorBoundary } from './components/atoms';
import { ToastContainer } from 'react-toastify';
import { Layout } from './components/Layout';
import { PaymentHelpPage, PaymentPage, PaymentRedirect, PaymentStatus, ReceiptAuth, ReceiptDashboard } from './pages';
import { useClarity, useGoogleAnalytics, useMixPanel, usePreconnect, useUnload } from './hooks';
import classes from './App.module.scss';
import './styles/scss/global.scss';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
    useGoogleAnalytics();
    useClarity();
    useMixPanel();
    // useUnload();
    usePreconnect();

    return (
        <div className="App">
            <ScrollToTop />
            <Layout>
                <Routes>
                    <Route
                        path="/help"
                        element={
                            <ErrorBoundary>
                                <Suspense
                                    fallback={
                                        <div className={classes.FullPageLoader}>
                                            <LogoLoader />
                                        </div>
                                    }
                                >
                                    <PaymentHelpPage />
                                </Suspense>
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/:slug/r/auth"
                        element={
                            <ErrorBoundary>
                                <Suspense
                                    fallback={
                                        <div className={classes.FullPageLoader}>
                                            <LogoLoader />
                                        </div>
                                    }
                                >
                                    <ReceiptAuth />
                                </Suspense>
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/:slug/r/dashboard"
                        element={
                            <ErrorBoundary>
                                <Suspense
                                    fallback={
                                        <div className={classes.FullPageLoader}>
                                            <LogoLoader />
                                        </div>
                                    }
                                >
                                    <ReceiptDashboard />
                                </Suspense>
                            </ErrorBoundary>
                        }
                    />
                    <Route path="/payment-status" element={<PaymentStatus />} />
                    <Route path="/payment-redirect" element={<PaymentRedirect />} />
                    <Route path="/:slug" element={<PaymentPage />} />
                    <Route path="*" element={<Navigate to="/help" />} />
                </Routes>
            </Layout>
            <ToastContainer position="top-center" theme="colored" />
        </div>
    );
};

export default App;
